import { makeStyles } from "@material-ui/core";
import * as yup from "yup";

export const stylesUse = makeStyles(theme=>({
    imageStyle:{
        width: 80,
        height: 80,
        objectFit: "contain"
    },
    imageStyleLg:{
        width: 300,
        height: 160,
        objectFit: "contain"
    },
}))

export const serviceSchema = yup.object({
    titleTh: yup.string().required("Title Thai is required."),
    titleEn: yup.string().required("Title Eng is required."),
    fileIcons: yup.array().required("Icon is required."),
    fileImages: yup.array().required("Image is required."),
    contentTh: yup.string().required("Content Thai is required."),
    contentEn: yup.string().required("Content Eng is required."),
});

export const initialValues = {
    titleTh: "",
    titleEn: "",
    fileImages: [],
    fileIcons: [],
    contentTh: "",
    contentEn: "",
};
